import { render } from "./PaginatorContent.vue?vue&type=template&id=2e3b9c56&ts=true"
import script from "./PaginatorContent.vue?vue&type=script&lang=ts"
export * from "./PaginatorContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__